import { render, staticRenderFns } from "./ReviewsFilter.vue?vue&type=template&id=014d2592"
import script from "./ReviewsFilter.vue?vue&type=script&lang=js"
export * from "./ReviewsFilter.vue?vue&type=script&lang=js"
import style0 from "./ReviewsFilter.vue?vue&type=style&index=0&id=014d2592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports